// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3cmoV","label":"styles_label__34mL5"};